import React from "react"
import { cancelButton, shadeSelectorFooter } from "./ShadeSelectorModal.css"

export type Props = {
  onCloseModal: React.Dispatch<React.SetStateAction<boolean>>
  styleVariant?: "default" | "stickyFooter"
  children?: React.ReactNode
  showCancelButton?: boolean
}

export const ShadeSelectorModalFooter: React.FC<Props> = ({
  onCloseModal,
  styleVariant = "default",
  children,
  showCancelButton = "true",
}) => {
  const toggleDrawer = () => {
    onCloseModal(false)
  }

  if (!children && !showCancelButton) return null

  return (
    <div className={`${shadeSelectorFooter[styleVariant]}`}>
      {children}
      {showCancelButton && (
        <button
          type="button"
          onClick={() => toggleDrawer()}
          onKeyDown={() => toggleDrawer()}
          tabIndex={0}
          aria-label="Cancel"
          className={cancelButton}
        >
          Cancel
        </button>
      )}
    </div>
  )
}
